import airwayData from '../data/pedsairways.json';

export function calculateAgeCategory(age: number, height: number, weight: number, hasSyndrome: boolean): string {
  // Convert age to months for easier comparison
  const ageInMonths = age * 12;

  // Convert to days for more precise preterm and newborn categorization
  const ageInDays = ageInMonths * 30.44;

  // Check if age is over 14 years (168 months)
  if (ageInMonths > 168) {
    throw new Error('Age must be 14 years or younger');
  }

  if (ageInDays < 0) return 'Preterm';
  if (ageInDays < 30) return 'Under 1 mo';
  if (ageInMonths <= 6) return '1-6 mo';
  if (ageInMonths <= 18) return '6-18 mo';
  if (ageInMonths <= 36) return '1.5 - 3 years';
  if (ageInMonths <= 72) return '3 - 6 years';
  if (ageInMonths <= 108) return '6 - 9  years';
  if (ageInMonths <= 144) return '9-12 years';
  if (ageInMonths <= 168) return '12 - 14 years';
  return 'Adult';
}

interface AirwayMeasurements {
  trachea: {
    transverseDiameter: number;
  };
  cricoid: {
    apDiameter: number;
  };
}

interface DeviceMeasurements {
  Size: string;
  'Transverse diameter (mm)': string;
  'AP Diameter (mm)': string;
  'ID (mm)': string;
  'OD (mm)': string;
  'Neo Length (mm)'?: string;
  'Ped Length (mm)'?: string;
  'Long Length (mm)'?: string;
  'Flextend Length (mm)'?: string;
}

export function calculateAirwayMeasurements(ageCategory: string): AirwayMeasurements {
  // Get measurements from Trachea and Cricoid devices
  const tracheaDevice = airwayData['Trachea '];
  const cricoidDevice = airwayData['Cricoid'];

  const tracheaMeasurements = tracheaDevice?.[ageCategory as keyof typeof tracheaDevice] as DeviceMeasurements | undefined;
  const cricoidMeasurements = cricoidDevice?.[ageCategory as keyof typeof cricoidDevice] as DeviceMeasurements | undefined;

  return {
    trachea: { 
      transverseDiameter: tracheaMeasurements ? parseFloat(tracheaMeasurements['Transverse diameter (mm)'].replace('<', '') || '0') : 0 
    },
    cricoid: { 
      apDiameter: cricoidMeasurements ? parseFloat(cricoidMeasurements['AP Diameter (mm)'].replace('<', '') || '0') : 0 
    }
  };
} 